import { Event } from "../../contracts";
import { CardConfiguration, EventsBySportType } from "../../typings";
import { setSportId } from "../../helpers";

/**
 * Group events received against cardConfiguration
 * @param events
 * @param cardConfig
 */
export const groupEventsBySport = (events: Event[], cardConfig: CardConfiguration): EventsBySportType => {
    let eventsBySport: EventsBySportType = {};
    let sportIds: string[] = Object.keys(cardConfig);
    let eventSportId: string;

    Object.keys(cardConfig).map(sportId => {
        let availableEvents = events.filter(e => {
            eventSportId = setSportId(sportIds, e);
            return eventSportId === sportId.toString();
        });

        eventsBySport[sportId] = availableEvents;
    });

    return eventsBySport;
}